import { noop } from 'lodash';
import {
  formatCaseData,
  formatClientData,
  formatReferralData,
} from 'src/components/Search/utils';
import { EXTERNAL_ID_LABEL, MEDICAID_ID_LABEL, MODELS } from 'src/components/Search/constants';

const { contact, referral, servicecase } = MODELS;

const defaultHeaders = [
  { label: 'Name - Service Type', value: 'name_service_type' },
  { label: 'Created', value: 'created_at' },
  { label: 'Status', value: 'status' },
];

function getSearchBarColumnHeaders(
  model,
  clientIdStandardizationEnabled = false,
  medicaidFilteringEnabled = false,
) {
  switch (model) {
    case contact: {
      const headers = [
        { label: 'Name', value: 'full_name', ariaLabel: 'name' },
        { label: 'Phone', value: 'phone', ariaLabel: 'phone' },
        { label: 'DOB', value: 'dob', ariaLabel: 'date of birth' },
        { label: 'Location', value: 'location', ariaLabel: 'location' },
      ];

      if (clientIdStandardizationEnabled || medicaidFilteringEnabled) {
        const label = medicaidFilteringEnabled ? MEDICAID_ID_LABEL : EXTERNAL_ID_LABEL;
        const value = 'external_id';
        const ariaLabel = label;
        headers.splice(1, 0, { label, value, ariaLabel });
      }

      return {
        getRowValues: formatClientData,
        headers,
      };
    }
    case referral: {
      return {
        getRowValues: formatReferralData,
        headers: defaultHeaders,
      };
    }
    case servicecase: {
      return {
        getRowValues: formatCaseData,
        headers: defaultHeaders,
      };
    }
    default: {
      return {
        getRowValues: noop,
        headers: [],
      };
    }
  }
}

export default getSearchBarColumnHeaders;
